import React from "react";

interface AnimatedTextProps {
  text: string;
  duration?: number;
  delayStep?: number;
}

const AnimatedText: React.FC<AnimatedTextProps> = ({
  text,
  duration = 1.5,
  delayStep = 0.1,
}) => {
  return (
    <span className="pathbee-animated-text">
      {text.split("").map((letter, index) => (
        <span
          key={index}
          className="pathbee-animated-letter"
          style={{
            animationDelay: `${index * delayStep}s`,
            animationDuration: `${duration}s`,
          }}
        >
          {letter}
        </span>
      ))}
    </span>
  );
};

export default AnimatedText;
